"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'login-api/v1';

var SingleSignOnLoginAPI =
/*#__PURE__*/
function () {
  function SingleSignOnLoginAPI() {
    (0, _classCallCheck2.default)(this, SingleSignOnLoginAPI);
  }

  (0, _createClass2.default)(SingleSignOnLoginAPI, null, [{
    key: "getLoginRedirect",
    value: function getLoginRedirect(data) {
      return _apiClient.default.post(API_BASE + "/saml/login", {
        data: data
      });
    }
  }, {
    key: "openWindow",
    value: function openWindow(toUrl) {
      window.open(toUrl, 'window', 'toolbar=no, menubar=no, resizable=yes, height=850, width=775');
    }
  }]);
  return SingleSignOnLoginAPI;
}();

exports.default = SingleSignOnLoginAPI;
module.exports = exports.default;